<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Edit Informasi Umum</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <b-form-group label="Nama Informasi">
                        <b-form-input v-model="input.namaInformasi" name="namaInformasi" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="Jenis Informasi">
                        <b-form-select v-model="input.jenisInformasi" name="jenisInformasi" :options="jenisInformasi" value-field="id" text-field="name" required>
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label="File Informasi">
                        <b-form-file
                            class="file-informasi-input"
                            v-model="input.fileInformasi" name="fileInformasi"
                            :state="Boolean(input.fileInformasi)"
                            placeholder="Choose a file"
                            drop-placeholder="Drop file here..."
                            ></b-form-file>
                        <template slot="description" v-if="input.urlFileInformasi != null">
                            Terdapat file: <a :href="$baseFilePath+input.urlFileInformasi" target="blank">Buka File</a>
                        </template>
                    </b-form-group>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="InformasiUmumUpdateBtn" variant="pgiBtn">Update</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-edit" title="Confirm Edit Informasi Umum" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah Informasi umum ini?" @submit="onSubmit" />
    </div>
</template>

<script>
export default {
    name: 'edit-Informasi-umum',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            input: {
                namaInformasi: "",
                jenisInformasi: null,
                fileInformasi: null,
                urlFileInformasi: null
            },
            jenisInformasi:[],
        }
    },
    methods: {
        //----------------- Fungsi Inisialisasi -----------------

        init() {

            this.initStatus = 0
            this.id = this.$route.params.id

            let getJenisInformasi = this.$axios.get('informasi-umum/jenis').then(response => {
                this.jenisInformasi = response.data
            })

            let getSingleInformasi = this.$axios.get(`informasi-umum/${this.id}`).then(response => {
                let Informasi = response.data

                this.input.namaInformasi = Informasi.name
                this.input.jenisInformasi = Informasi.jenis.id
                this.input.urlFileInformasi = Informasi.path

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getJenisInformasi]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },


        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            let payload = new FormData()

            //----------------- Append Data Role -----------------
            
            payload.append("id", this.id)
            payload.append("name", this.input.namaInformasi)
            payload.append("jenisId", this.input.jenisInformasi)
            if (this.input.fileInformasi == null) payload.append('file', this.$helper.createEmptyFile())
            else payload.append('file', this.input.fileInformasi)


            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("informasi-umum/", payload).then(response => {
                this.$helper.setFlash(`Informasi Umum telah berhasil diubah!`)
                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            this.$bvModal.show("modal-confirm-edit")
        }

    },

    created(){
        this.init()
    }

}
</script>

<style scoped>
::v-deep .file-informasi-input .custom-file {
    height: calc(1.5em + 0.75rem + 2px);
}

::v-deep .file-informasi-input .custom-file-label {
    height: calc(1.5em + 0.75rem + 2px);
    display: block;
    padding-right: 7rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

::v-deep .file-informasi-input .custom-file-label::after {
    height: 100%;
}
</style>
